import { createAction } from '@reduxjs/toolkit';

/* Action Types */
enum ActionTypes {
	SET_CONFIRM_SOIL_INVESTIGATIONS_DELETE_DIALOG_OPEN = '@@mondriaan/SOIL_INVESTIGATIONS_DELETION_DIALOG/CONFIRM',
}

export const setConfirmSoilInvestigationsDeletionDialogOpen = createAction<boolean>(ActionTypes.SET_CONFIRM_SOIL_INVESTIGATIONS_DELETE_DIALOG_OPEN);
